<template>
  <v-container fluid>
    <h1 class="text-h1 mb-3">{{$t('order.title')}}</h1>
    <v-card class="mb-12" max-width="600">
      <v-card-text>
        <p>
          {{$t('order.messages.descriptionNotAvailableInWMS')}}
        </p>
        <p>
          {{$t('order.messages.descriptionExplanation')}}
        </p>
        <div class="mb-4">
          {{$t('order.messages.possibleCauses')}}
          <ul>
            <li>{{$t('order.messages.orderReceivedWhenInactive')}}</li>
            <li>{{$t('order.messages.technicalError')}}</li>
          </ul>
        </div>
        <p>
          {{$t('order.messages.receiveLatestCount')}}
        </p>

        <div v-if="orders" class="mb-4">
          <p v-if="orders.salesOrders" class="mb-0">{{ $t('order.messages.salesOrdersText', { count: orders.salesOrders.count }) }}</p>
          <p v-if="orders.purchaseOrders" class="mb-0">{{ $t('order.messages.purchaseOrdersText', { count: orders.purchaseOrders.count }) }}</p>
          <p v-if="orders.returnOrders" class="mb-0">{{ $t('order.messages.returnOrdersText', { count: orders.returnOrders.count }) }}</p>

          <VRow>
            <VCol cols="7">
              <KTextField field="limit" v-show="!disableLimit" v-model="limit" type="number" min="1" :label="$t('order.fields.limit')" />
            </VCol>
            <VCol cols="5">
              <KCheckbox field="disableLimit" class="mb-1" v-model="disableLimit" :label="$t('order.fields.disableLimit')" />
            </VCol>
          </VRow>
        </div>

        <div v-if="canSubmitOrdersToWarehouse" class="flex-row ga-2 d-flex">
          <VBtn @click="postOrders" color="primary" :disabled="disableSubmitButton || isFetchingData" :loading="isSubmitting">
            {{ $t('order.actions.confirm') }}
          </VBtn>
          <VBtn @click="getOrders" color="primary" :disabled="isSubmitting" :loading="isFetchingData" text>
            {{ $t('order.actions.refresh') }}
          </VBtn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { warehouseOrders, confirmWarehouseOrders } from "@/api/endpoints/order";
import Vue from "vue";
import EventBus from "@/eventBus";
import { mapGetters } from "vuex";
import KTextField from "@/components/crud/fields/KTextField.vue";
import KCheckbox from "@/components/crud/fields/KCheckbox.vue";

export default Vue.extend({
  name: 'WarehouseOrderOverview',
  components: { KCheckbox, KTextField },
  data() {
    return {
      orders: null,
      isSubmitting: false,
      isFetchingData: false,
      limit: 1,
      disableLimit: false,
    };
  },
  created() {
    this.getOrders();
  },

  computed: {
    ...mapGetters("profile", ["can"]),
    disableSubmitButton() {
      return this.orders?.salesOrders?.count === 0 && this.orders?.purchaseOrders?.count === 0 && this.orders?.returnOrders?.count === 0;
    },
    canSubmitOrdersToWarehouse() {
      return this.can('dwh-configuratie.all');
    }
  },
  methods: {
    async getOrders() {
      if (this.isFetchingData) return;

      this.isFetchingData = true;
      const response = await warehouseOrders();
      this.orders = response.data.data;
      this.isFetchingData = false;
    },
    postOrders() {
      if(!this.canSubmitOrdersToWarehouse) return;

      const localLimit = this.disableLimit ? undefined : this.limit;

      EventBus.$emit('confirm', {
        title: this.$t('order.messages.confirmationDialog.title'),
        body: this.$t('order.messages.confirmationDialog.body'),
        confirmCallback: async () => {
          this.isSubmitting = true;
          const response = await confirmWarehouseOrders(localLimit);
          this.orders = response.data.data;
          this.isSubmitting = false;
        },
      });
    },
  },
});
</script>
